import ClearancesContainer from "@features/port-security/components/ClearancesContainer";
import IdChecker from "@features/port-security/components/id-checker/IdChecker";
import OccupationInfoForm from "@features/port-security/components/occupation-info/OccupationInfoForm";
import PersonalInfoForm from "@features/port-security/components/personal-info/PersonalInfoForm";
import SecurityClearanceApplicationForm from "@features/port-security/components/security-clearance-application/SecurityClearanceApplicationForm";
import SecurityClearanceForm from "@features/port-security/components/security-clearance-form/SecurityClearanceForm";
import SecurityClearanceRequestPreview from "@features/port-security/components/security-clearance-request-preview/SecurityClearanceRequestPreview";
import SecurityClearanceContainer from "@features/port-security/components/SecurityClearanceContainer";
import SocialInfoForm from "@features/port-security/components/social-info/SocialInfoForm";
import SecurityClearancePage from "@pages/port-security/SecurityClearancePage";
import { paths } from "@utils/navigation";
import { type AppRoute } from "../types";

export const getPortSecurityRoutes = (): AppRoute => ({
  path: paths.portSecurity.index,
  protected: true,
  element: <SecurityClearancePage />,
  requiredPermissions: ["hasSecurityClearanceAccess", "hasSecurityClearanceRequestAccess"],
  children: [
    { index: true, redirectTo: paths.portSecurity.clearances },
    { path: paths.portSecurity.clearances, element: <ClearancesContainer /> },
    {
      path: paths.portSecurity.requestSecurityClearance,
      element: <SecurityClearanceContainer />,
      children: [
        { path: paths.portSecurity.checkId, element: <IdChecker /> },
        {
          path: paths.portSecurity.clearanceForm,
          element: <SecurityClearanceForm />,
          children: [
            { index: true, redirectTo: paths.portSecurity.personalInfo },
            { path: paths.portSecurity.personalInfo, element: <PersonalInfoForm /> },
            { path: paths.portSecurity.socialInfo, element: <SocialInfoForm /> },
            { path: paths.portSecurity.occupationInfo, element: <OccupationInfoForm /> },
            {
              path: paths.portSecurity.securityClearanceApplication,
              element: <SecurityClearanceApplicationForm />,
            },
          ],
        },
      ],
    },
    {
      path: `${paths.portSecurity.securityClearanceRequestPreview}/:id`,
      element: <SecurityClearanceRequestPreview />,
    },
  ],
});
